import { render, staticRenderFns } from "./ClinicItemsIncomeReport.vue?vue&type=template&id=fa214e2c"
import script from "./ClinicItemsIncomeReport.vue?vue&type=script&lang=js"
export * from "./ClinicItemsIncomeReport.vue?vue&type=script&lang=js"
import style0 from "./ClinicItemsIncomeReport.vue?vue&type=style&index=0&id=fa214e2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports